//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex'
import { } from 'element-ui'
import formWrapper from '../../components/pc/formWrapper'
import formInput from '../../components/pc/formInput'
import formVCode from '../../components/pc/formVCode'
import { isEmpty } from 'lodash'

export default {
  components: {
    formWrapper,
    formInput,
    formVCode
  },
  async created () {
    this.$wisLoading(false)
  },
  async mounted () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isEmpty,
      form: {
        contactUsername: '',
        saleCorpName: '',
        mobile: '',
        mobileValidateCode: ''
      }
    }
  },
  computed: {
    ...mapState('common', []),
    ...mapGetters('common', [])
  },
  watch: {},
  filters: {},
  methods: {
    ...mapActions('website', ['websiteTrialSalerAdd']),

    async submit () {
      let formInputDomList = this.$children[0].$children.filter(el => /(FormInput|FormVCode)/g.test(el.$vnode.tag))
      if (formInputDomList.map(el => el.validate()).indexOf(false) > -1) return
      this.$wisLoading(true)
      let params = { ...this.form }
      await this.websiteTrialSalerAdd(params)
      this.$refs.vcodeDom.clear()
      this.$wisLoading(false)
      this.$message({
        message: '提交成功，我们工作人员会主动联系您',
        type: 'success',
        duration: 10000,
        showClose: true
      })
      this.$router.push({
        path: '/'
      })
    }
  }
}
